

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Urlify extends Vue {
  @Prop({ required: true })
  public text!: string;
  @Prop({ default: "p" })
  public tag!: string;

  public get type() {
    return {
      TEXT: 0,
      URL: 1
    };
  }

  public get urlifiedMessages() {
    return this.urlify();
  }

  public openLink(url) {
    url = url.match(/^https?:/) ? url : "//" + url;
    window.open(url, "_blank");
  }

  public urlify() {
    const data = [{ type: this.type.TEXT, value: this.text }];
    let current = this.text;
    let match: RegExpExecArray | null = null;
    do {
      const urlRegex = /((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$]))/im;
      match = urlRegex.exec(current);
      if (!this.$_.isEmpty(match)) {
        match = match as RegExpExecArray;
        data.pop();
        const value = (match as RegExpExecArray)[1] || "";
        data.push({
          type: this.type.TEXT,
          value: current.substr(0, match.index)
        });
        data.push({
          type: this.type.URL,
          value
        });
        data.push({
          type: this.type.TEXT,
          value: current.substr(match.index + value.length)
        });
        current = current.substr(match.index + value.length);
      }
    } while (match);
    return data;
  }
}
